import { NRLogger } from '../logging/nrLogging'
let recaptchaPromise = null
export class ReCaptcha {
  siteKey
  scriptId
  scriptLoadingPromise = null
  // scriptId

  constructor(siteKey) {
    this.scriptId = `ssh-recaptcha-${this.getSiteKeyHash(siteKey)}`
    this.init(siteKey)
    this.siteKey = siteKey
  }

  getSiteKeyHash(siteKey) {
    return siteKey.slice(0, 8)
  }

  isLoaded() {
    if (window?.grecaptcha || !!document.getElementById(this.scriptId)) return true

    return false
  }

  async init(siteKey) {
    if (recaptchaPromise) return recaptchaPromise
    recaptchaPromise = new Promise((resolve, reject) => {
      if (this.isLoaded()) resolve()
      const script = document.createElement('script')
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`
      script.id = this.scriptId
      script.async = true
      script.defer = true

      script.onerror = (e) => {
        NRLogger.error('UBIK Help Center - Recaptcha init', {
          httpRequestStatus: 500,
          message: e,
        })
        console.error(e)
        reject(new Error('An Error occured when loading recaptcha'))
        console.error('An Error occured when loading recaptcha')
      }
      script.onload = () => {
        NRLogger.info('UBIK Help Center - Recaptcha', {
          httpRequestStatus: 200,
          message: 'Recaptcha loaded',
        })
        resolve()
      }
      document.head.appendChild(script)
    })
    return recaptchaPromise
  }

  async retryRecaptcha(action) {
    let attempts = 0
    const maxRetries = 3
    const delay = 500
    const recaptcha = window.grecaptcha?.enterprise ? window.grecaptcha.enterprise : window.grecaptcha
    while (attempts < maxRetries) {
      attempts++
      try {
        // Wait for the grecaptcha to be ready
        await new Promise((resolve, reject) => {
          recaptcha.ready(() => {
            try {
              NRLogger.info('UBIK Help Center - Recaptcha', {
                message: 'grecaptcha.ready',
              })
              resolve()
            } catch (error) {
              reject(error)
            }
          })
        })

        // Execute the grecaptcha and get the token
        return await recaptcha.execute(this.siteKey, { action })
      } catch (error) {
        console.warn('Recaptcha v3 retry attempt:', attempts, error)
        NRLogger.info('UBIK Help Center - Recaptcha retry', {
          httpRequestStatus: 401,
          message: `Something went wrong while trying to execute recaptcha, attempt number : ${attempts}`,
        })
        await new Promise((resolve) => setTimeout(resolve, delay))
      }
    }
    const errorMsg = 'Recaptcha v3 failed after all retries'
    NRLogger.error('UBIK Help Center - Recaptcha', { message: errorMsg })
    throw new Error(errorMsg)
  }

  async generateRecaptchaToken(action) {
    try {
      if (!this.isLoaded()) {
        await this.init(this.siteKey)
      }
      return await this.retryRecaptcha(action)
    } catch {
      NRLogger.error('UBIK Help Center - Recaptcha execute', {
        httpRequestStatus: 500,
        message: 'Recaptcha v3 failed after all retries',
      })
      return null
    }
  }
}
